(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('ngConfirm', ngConfirm);

    ngConfirm.$inject = ['$uibModal'];

    function ngConfirm($uibModal) {
        return {
            restrict: 'A',
            scope: {
                ngConfirmMessage: '@',
                ngConfirmTitle: '@',
                ngCancelCaption: '@',
                ngConfirmCaption: '@',
                ngConfirm: '&',
                ngCancel: '&',
                ngButtonClass: '@',
                ngIconClass: '@',
                ngCancelButtonClass: '@',
                ngCancelIconClass: '@'
            },
            link: function (scope, element) {
                element.bind('click', function () {
                    var modal = $uibModal.open({
                        templateUrl: 'app/components/confirm/confirm-dialog.html',
                        controller: 'ModalConfirmController',
                        size: 'md',
                        windowClass: 'confirm-window',
                        resolve: {
                            confirmMessage: function () {
                                return scope.ngConfirmMessage;
                            },
                            confirmTitle: function () {
                                return scope.ngConfirmTitle;
                            },
                            confirmCaption: function () {
                                return scope.ngConfirmCaption;
                            },
                            buttonClass: function () {
                                return scope.ngButtonClass;
                            },
                            iconClass: function () {
                                return scope.ngIconClass;
                            },
                            cancelCaption: function () {
                                return scope.ngCancelCaption;
                            },
                            cancelButtonClass: function () {
                                return scope.ngCancelButtonClass;
                            },
                            cancelIconClass: function () {
                                return scope.ngCancelIconClass;
                            }
                        }
                    });

                    modal.result.then(function () {
                        scope.ngConfirm();
                    }, function () {
                        scope.ngCancel();
                    });
                });
            }
        }
    }
})();
